import React, { useState } from "react";
import {
  SecondaryButton,
  formatShortDate,
  formatSquadInfo,
} from "../../UI/DesignStandards";
import AverageProofViewer from "../../Signup/AverageProofViewer";
import {
  bowlerNames,
  moneyLabel,
  placementLabel,
} from "../../../utility/signupDashboard";

const SignupHeader = ({ signup, tournamentName }) => {
  const [proofOpen, setProofOpen] = useState(false);
  if (!signup) return null;

  const placement = placementLabel(signup);
  const money = moneyLabel(signup);
  const squad = signup.squad;

  return (
    <div className="card-board overflow-hidden">
      <div className="bg-brand-charcoal text-brand-cream px-6 py-4">
        <h1 className="font-display font-bold text-xl text-brand-cream tracking-tight">
          Signup
        </h1>
        <p className="text-sm text-brand-mist mt-1">
          Who signed up, what they owe, and waitlist actions.
        </p>
      </div>
      <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
        <div>
          <span className="font-medium text-brand-charcoal">Bowlers</span>
          <span className="ml-2 text-brand-muted">{bowlerNames(signup)}</span>
        </div>
        <div>
          <span className="font-medium text-brand-charcoal">Status</span>
          <span className="ml-2 text-brand-muted">
            {placement}
            {money ? ` · ${money}` : ""}
            {signup.refundRequested ? " · Refund requested" : ""}
          </span>
        </div>
        <div>
          <span className="font-medium text-brand-charcoal">Tournament</span>
          <span className="ml-2 text-brand-muted">
            {tournamentName}
            {signup.tournamentEvents?.eventName
              ? ` · ${signup.tournamentEvents.eventName}`
              : ""}
          </span>
        </div>
        <div>
          <span className="font-medium text-brand-charcoal">Email</span>
          <span className="ml-2 text-brand-muted">{signup.email}</span>
        </div>
        <div>
          <span className="font-medium text-brand-charcoal">Squad</span>
          <span className="ml-2 text-brand-muted">
            {squad
              ? formatSquadInfo(squad.squadDate, squad.squadTime)
              : "No squad"}
          </span>
        </div>
        <div>
          <span className="font-medium text-brand-charcoal">Submitted</span>
          <span className="ml-2 text-brand-muted">
            {formatShortDate(signup.created || signup.createdAt)}
          </span>
        </div>
        {signup.averageProofPath ? (
          <div className="md:col-span-2">
            <SecondaryButton
              onClick={() => setProofOpen(true)}
              className="!px-3 !py-2 text-sm"
            >
              Average verification
            </SecondaryButton>
          </div>
        ) : null}
      </div>
      <AverageProofViewer
        isOpen={proofOpen}
        onClose={() => setProofOpen(false)}
        storagePath={signup.averageProofPath}
      />
    </div>
  );
};

export default SignupHeader;
